import React, { useState } from 'react';
import { GlassCard } from '../shared/GlassCard';
import { GradientText } from '../shared/GradientText';
import AutoDrawModal from './AutoDrawModal';

const features = [
  'Never miss a draw — automatic entry every round',
  'Set recurring entries with custom schedules',
  'Maximum consistency for the player',
  'Steady liquidity for the ecosystem',
  'Stop conditions: after X wins or balance below Y',
];

function AutoDrawFeatureSection() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <section className="relative py-24">
      <div className="absolute inset-0 bg-dark" />
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/images/backround-autodraw.png)',
          opacity: 0.15,
        }}
      />
      <div className="absolute inset-0 lightning-bg opacity-30" />
      <div className="absolute top-0 left-0 right-0 h-px glow-separator-blue" />

      <div className="container-premium relative z-10">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-medora-blue/10 border border-medora-blue/20 mb-6">
              <img src="/images/icon-autodraw.svg" alt="AutoDraw" className="w-4 h-4" />
              <span className="text-medora-blue text-sm font-semibold">AutoDraw Feature</span>
            </div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
              <GradientText variant="hash" className="text-3xl sm:text-4xl lg:text-5xl font-bold">Set It &</GradientText>{' '}
              <GradientText variant="medora" className="text-3xl sm:text-4xl lg:text-5xl font-bold">Forget It</GradientText>
            </h2>

            <p className="text-gray-400 text-lg mb-8 leading-relaxed">
              The AutoDraw function serves as the "engine" of the platform. Set recurring entries
              and schedules so you never miss a draw again.
            </p>

            <ul className="space-y-4 mb-8">
              {features.map((feature, index) => (
                <li key={index} className="flex items-center gap-3">
                  <div className="w-5 h-5 rounded-full bg-hash-gold/20 flex items-center justify-center flex-shrink-0">
                    <svg className="w-3 h-3 text-hash-gold" fill="currentColor" viewBox="0 0 20 20">
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <span className="text-gray-300 text-sm">{feature}</span>
                </li>
              ))}
            </ul>

            {/* <button
              onClick={() => setModalOpen(true)}
              className="btn-blue-outline inline-flex items-center gap-2 px-8 py-3 rounded-xl"
            >
              <img src="/images/icon-autodraw.svg" alt="" className="w-5 h-5" />
              Configure AutoDraw
            </button> */}
          </div>

          {/* Right - Visual */}
          <GlassCard variant="premium" className="p-8">
            <div className="space-y-4">
              <div className="flex items-center justify-between p-4 rounded-xl bg-dark-surface/50 border border-hash-gold/10">
                <div className="flex items-center gap-3">
                  <img src="/images/icon-strike.png" alt="" className="w-10 h-10 object-contain" />
                  <div>
                    <div className="text-white font-semibold text-sm">Hash-Strike</div>
                    <div className="text-gray-500 text-xs">Every Draw</div>
                  </div>
                </div>
                <div className="text-hash-gold font-bold text-sm">Active</div>
              </div>

              <div className="flex items-center justify-between p-4 rounded-xl bg-dark-surface/50 border border-medora-blue/10">
                <div className="flex items-center gap-3">
                  <img src="/images/icon-vault.png" alt="" className="w-10 h-10 object-contain" />
                  <div>
                    <div className="text-white font-semibold text-sm">Hash-Vault</div>
                    <div className="text-gray-500 text-xs">Every Draw</div>
                  </div>
                </div>
                <div className="text-medora-blue font-bold text-sm">Active</div>
              </div>

              <div className="flex items-center justify-between p-4 rounded-xl bg-dark-surface/50 border border-hash-gold/10">
                <div className="flex items-center gap-3">
                  <img src="/images/icon-summit.png" alt="" className="w-10 h-10 object-contain" />
                  <div>
                    <div className="text-white font-semibold text-sm">Summit Draw</div>
                    <div className="text-gray-500 text-xs">Next event: June 1th</div>
                  </div>
                </div>
                <div className="text-gray-500 font-bold text-sm">Upcoming</div>
              </div>
            </div>
          </GlassCard>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px glow-separator-blue" />
      <AutoDrawModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </section>
  );
}

export default AutoDrawFeatureSection;
